import axios from "axios";
import { relationshipChatUrl } from "./Controller/URLConstants";
import { getSessionToken } from "./sessionFunctions";

// Ensures the current admin is a participant of a relationship's canonical
// v2 chat, adding them (if authorized) when they've never opened this
// candidate's conversation before. The Firestore-backed chat list only ever
// contains chats the admin already belongs to, so this is required before
// navigating to a relationship chat that might not be in that list yet —
// otherwise the send endpoint rejects the first message from a new admin.
// Returns the chat (with chatId), or null if the request failed.
export async function ensureRelationshipChat(relationshipId) {
  if (!relationshipId) return null;

  try {
    const token = await getSessionToken();
    const response = await axios.post(
      relationshipChatUrl(relationshipId),
      {},
      { headers: token ? { "x-access-token": token } : {} },
    );

    if (response.data?.status === 0) {
      return response.data.chat ?? null;
    }
    return null;
  } catch (error) {
    console.error("Failed to ensure relationship chat:", error);
    return null;
  }
}
